import { useTranslation } from 'react-i18next'
import type { TopModel } from 'core/api/home/useApiGetTeamLastFourWeeksPerformance'
import ProductModelCard from './product-model-card'

interface TopModelsContentProps {
  topGmvModel: TopModel
  topQuantityModel: TopModel
  currency: string
}

const TopModelsContent = ({ topGmvModel, topQuantityModel, currency }: TopModelsContentProps) => {
  const { t } = useTranslation()

  return (
    <div className="mg-last-four-weeks-products">
      <ProductModelCard
        model={topGmvModel}
        currency={currency}
        stickerLabel={t('homepage.last-four-weeks-team-performance.top-gmv')}
      />
      <ProductModelCard
        model={topQuantityModel}
        currency={currency}
        stickerLabel={t('homepage.last-four-weeks-team-performance.top-quantity')}
      />
    </div>
  )
}

export default TopModelsContent
